webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(43),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Projects__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Journal__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Journal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Journal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Node__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Node___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Node__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_scrollto__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_touch__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_touch__);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_touch___default.a, { name: 'v-touch' });

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/:home(home)?',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
  }, {
    path: '/projects*',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Projects___default.a
  }, {
    path: '/journal*',
    name: 'Journal',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Journal___default.a
  }, {
    path: '/:title([a-zA-Z][a-zA-Z0-9_-]+)',
    name: 'Node',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Node___default.a
  }]
}));

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(44),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function scrollY() {
  if (window.pageYOffset) {
    return window.pageYOffset;
  }
  return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
}

function winWidth() {
  if (document.documentElement && document.documentElement.clientWidth) {
    return document.documentElement.clientWidth;
  }
  if (document.body) {
    return document.body.clientWidth;
  }
}

function isTouchDevice() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function () {
      supportsPassive = true;
    }
  });
  window.addEventListener("test", null, opts);
} catch (e) {}

var passiveProps = supportsPassive ? { passive: true } : false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function () {
    return {
      loading: false,
      alias: 'home',
      section: 'main',
      infoLoaded: false,
      touchEnabled: false,
      touchActive: false,
      nodes: [],
      menu: [],
      menu_toggle_label: 'Menu',
      owner: '',
      content: {},
      hasContent: false,
      siteName: 'Blustin Design',
      strapline: '',
      title: 'Welcome',
      isAdmin: false,
      adminUrl: "",
      currId: 0,
      showAdmin: false,
      backend: 'https://www.blustindesign.com/',
      mediabase: 'https://www.blustindesign.com/',
      containerClasses: [],
      statusMsg: '',
      showStatusMsg: false,
      footer: {
        copyright: '© 2018 Blustin Design',
        menu: [{ link: '/terms', 'title': 'Terms & conditions' }],
        email: ''
      },
      fullSizes: {
        'max_1600x1600': '(min-width:1301px)',
        'max_1300x1300': '(min-width:641px) and (max-width:1300px)',
        'max_720x720': '(max-width:640px)'
      },
      fixedSizes: {
        'scalecrop_1600_720': '(min-width:1441px)',
        'scalecrop_1440_648': '(min-width:1025px) and (max-width:1440px)',
        'scale_crop_1024_461': '(min-width:641px) and (max-width:1024px)',
        'scalecrop_720_960': '(max-width:640px) and (min-height:401px)',
        'scalecrop_720_324': '(max-width:640px) and (max-height:400px)'
      },
      landscapeFixedSizes: {
        'scalecrop_1024_742': '(min-width:1201px)',
        'scalecrop_640_464': '(max-width:1200px)'
      },
      portraitFixedSizes: {
        'scalecrop_720_960': '(min-width:0px)'
      },
      preloadedImgs: [],
      previewWidth: 640,
      stopY: 0,
      prevY: 0,
      pageHeight: 0,
      winHeight: 0,
      winWidth: 0,
      scrolling: false,
      allProjectsLoaded: false,
      isProjectPage: false
    };
  },
  created: function () {
    if (__webpack_require__.i({"NODE_ENV":"production","BACKEND":"https://www.blustindesign.com/","MEDIABASE":"https://www.blustindesign.com/"})) {
      if (true) {
        this.backend = "https://www.blustindesign.com/", this.mediabase = "https://www.blustindesign.com/";
      }
    }
    this.addContainerClass('loading');
    this.touchEnabled = isTouchDevice();
    if (this.touchEnabled) {
      this.addContainerClass('touch-enabled');
    }
    this.checkSiteInfo();
    this.checkLoggedin();
    this.handleResize(true);

    window.addEventListener('keydown', this.handleKeys);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll, passiveProps);
  },
  watch: {
    showAdmin: function () {
      if (this.showAdmin) {
        this.addContainerClass('has-overlay');
      } else {
        this.removeContainerClass('has-overlay');
      }
    },
    '$route.path': function () {
      this.updatePage();
    }
  },
  methods: {
    updatePage: function (init) {
      if (init !== true && this.section !== 'journal') {
        this.addContainerClass('loading');
      }
      this.removeContainerClass('show-menu');
      this.matchAlias();
      var loadingTs = 2000;
      switch (this.section) {
        case 'home':
          loadingTs = 4000;
          break;
        case 'projects':
          if (this.alias != 'projects') {
            this.$emit('show-project', { path: '/' + this.alias });
          } else {
            loadingTs = 3000;
          }
          break;
        case 'journal':
          loadingTs = 2000;
          break;
        default:
          this.loadPage();
          break;
      }
      var comp = this;
      setTimeout(function () {
        comp.removeContainerClass('loading');
        comp.updateTitle();
      }, loadingTs);
    },
    listen: function (item) {
      switch (item.link) {
        case '/projects':
          window.location.hash = '#all';
          break;
      }
    },
    updateTitle: function () {
      var el = document.querySelectorAll('h2');
      switch (this.alias) {
        case 'projects':
          el = document.querySelectorAll('.projects h2.content-title');
          break;
      }
      if (el.length > 0) {
        this.title = el[0].textContent;
      }
      document.title = this.title + ': ' + this.siteName;
    },
    matchAlias: function () {
      var path = this.$route.path;
      var alias = path.replace(/^\//, '');
      if (alias.length < 2) {
        alias = 'home';
      }
      this.alias = alias;
      this.section = alias.split('/').shift();
      this.isProjectPage = this.section == 'projects' && this.alias != 'projects';
    },
    loadPage: function () {
      if (this.alias.length > 1 && this.loading !== true) {
        var alias = this.alias;
        var comp = this;
        var index = _.findIndex(this.nodes, function (n) {
          return n.alias.replace(/^\//, '') === alias;
        });
        if (index >= 0) {
          this.loading = true;
          var node = this.nodes[index];
          var refName = 'node-full/' + node.nid;
          var reload = this.matchEdited(node) >= 0;
          this.loadData(refName, function (data) {
            comp.addArticle(data);
            comp.updateTitle();
          }, 'jsonstyles', reload);
        } else {
          setTimeout(function () {
            comp.addNotFound();
          }, 3000);
        }
      }
    },
    matchEdited: function (node) {
      var edited = this.$ls.get('editednodes');
      if (edited) {
        if (edited.total) {
          if (edited.total > 0) {
            return _.findIndex(edited.nodes, function (n) {
              return parseInt(n.nid) === parseInt(node.nid) && parseInt(n.changed) > parseInt(node.changed);
            });
          }
        }
      }
      return -1;
    },
    addNotFound: function () {
      if (!this.hasContent) {
        this.title = 'Page not found';
        this.content.body = 'This resource is not available';
        this.content.hasImage = false;
        this.hasContent = true;
        this.showTitle = true;
      }
    },
    addArticle: function (data, refName) {
      if (data.title) {
        this.currId = data.nid;
        this.content = data;
        this.title = data.title;
        this.hasContent = true;
        this.content.hasImage = false;
        this.showTitle = false;
        if (data.image) {
          if (data.image instanceof Object && data.image !== null) {
            this.content.hasImage = data.image.hasOwnProperty('sizes');
          }
        }
        this.$emit('node-update');
      }
      var comp = this;
      setTimeout(function () {
        comp.loading = false;
      }, 250);
    },
    editNode: function (id) {
      this.adminUrl = this.backend + 'node/' + id + '/edit';
      var comp = this;
      setTimeout(function () {
        comp.showAdmin = true;
      }, 500);
    },
    showAdminOverlay: function () {
      if (this.currId > 0) {
        this.editNode(this.currId);
      }
    },
    showAdminPage: function () {
      if (this.currId > 0) {
        window.open(this.adminUrl, "_BLANK");
      }
    },
    hideAdminOverlay: function () {
      this.showAdmin = false;
    },
    checkLoggedin: function () {
      var comp = this;
      var ts = new Date().getTime();
      this.$http.get(this.backend + '/jsonstyles/user?ts=' + ts).then(function (response) {
        if (response.data) {
          if (typeof comp === 'object') {
            comp.user = response.data;
            if (comp.user.roles) {
              comp.isAdmin = comp.user.is_editor;
            }
          }
        }
      }, function (response) {});
    },
    loadData: function (path, callback, prefix, reload) {
      if (!prefix) {
        prefix = 'jsonstyles';
      }
      var cacheKey = path.replace(/\//g, '_');
      var data = this.$ls.get(cacheKey, null);

      var hasCallback = typeof callback === 'function';
      var comp = this;
      if (reload !== true && (data instanceof Array || data instanceof Object && data.valid)) {
        if (hasCallback) {
          callback(data);
        }
      } else {
        var matched = false;
        if (hasCallback) {
          var preload_item = '';
          switch (path) {
            case 'home':
              preload_item = 'home_slides';
              break;
            case 'projects-full':
              preload_item = 'top_projects';
              break;
            default:
              preload_item = path.replace('-', '_').replace('/', '__');
              break;
          }
          if (preload_item.length > 0) {
            if ($preload.hasOwnProperty(preload_item)) {
              if ($preload[preload_item] !== null && $preload[preload_item] instanceof Object) {
                matched = true;
                callback($preload[preload_item]);
              }
            }
          }
        }
        if (!matched) {
          var qstr = '?r=' + (10 * Math.random()).toFixed(6);
          this.$http.get(this.backend + prefix + '/' + path + qstr).then(function (response) {
            if (response.data instanceof Array || response.data instanceof Object && response.data.valid) {
              comp.$ls.set(cacheKey, response.data, 24 * 60 * 60 * 1000);
              if (hasCallback) {
                callback(response.data);
              }
              if (response.data.nid) {
                comp.updateSiteInfoNode(response.data);
              } else if (response.data.items) {
                if (response.data.items instanceof Array) {
                  for (var i = 0; i < response.data.items.length; i++) {
                    if (response.data.items[i].nid) {
                      comp.updateSiteInfoNode(response.data.items[i]);
                    }
                  }
                }
              }
            }
          }, function (response) {});
        }
      }
    },
    updateSiteInfoNode: function (node) {
      var d = this.$ls.get('sitedata', null),
          pi = -1;
      if (d) {
        if (d.nodes) {
          pi = _.findIndex(d.nodes, function (n) {
            return n.nid == node.nid;
          });
        }
      }
      if (node.changed && pi >= 0) {
        d.nodes[pi].changed = node.changed;
        this.$ls.set('sitedata', d);
      }
    },
    getNode: function (nid) {
      this.loadData('node-full/' + nid);
    },
    checkSiteInfo: function () {
      var data = this.$ls.get('sitedata', null);
      var ts = new Date().getTime();
      var prevTs = this.$ls.get('ts');
      if (data !== null) {
        this.loadSiteInfo(data);
      } else {
        var matched = false;
        if ($preload) {
          if ($preload.site_info) {
            if ($preload.site_info.menu) {
              if ($preload.site_info.menu instanceof Array) {
                matched = true;
                this.loadSiteInfo($preload.site_info);
              }
            }
          }
        }
        if (!matched) {
          this.fetchSiteInfo(ts);
        }
      }
      if (ts - prevTs > 15 * 60 * 1000) {
        var comp = this;
        setTimeout(function () {
          comp.fetchSiteInfo(ts);
        }, 5000);
      }
    },
    fetchSiteInfo: function (ts) {
      var comp = this;
      this.$http.get(this.backend + 'jsonstyles/siteinfo').then(function (response) {
        if (response.data) {
          if (typeof response.data === 'object') {
            comp.loadSiteInfo(response.data);
            comp.$ls.set('sitedata', response.data, 7 * 24 * 60 * 60 * 1000);
            comp.$ls.set('ts', ts);
          }
        }
      }, function (response) {});
    },
    loadSiteInfo: function (data) {
      if (data.site_name) {
        this.siteName = data.site_name;
      }
      if (data.menu) {
        this.menu = data.menu;
      }
      if (data.footer) {
        if (data.footer.copyright) {
          this.footer.copyright = data.footer.copyright;
        }
        if (data.footer.menu) {
          if (data.footer.menu instanceof Array) {
            this.footer.menu = data.footer.menu;
          }
        }
        this.footer.email = '';
        if (data.footer.email) {
          if (typeof data.footer.email === 'string' && data.footer.email.length > 5) {
            this.footer.email = data.footer.email;
          }
        }
      }
      if (data.owner) {
        this.owner = data.owner;
      }
      if (data.strapline) {
        this.strapline = data.strapline;
      }
      if (data.nodes && data.nodes instanceof Array) {
        this.nodes = data.nodes;
        this.infoLoaded = true;
        this.updatePage(true);
      }
      var comp = this;
      if (this.section !== 'home') {
        setTimeout(function () {
          comp.loadData('home');
        }, 1500);
      }

      var checkEditedTs = this.section !== 'home' ? 2250 : 8000;

      setTimeout(function () {
        comp.checkEdited(true);
      }, 2250);

      if (this.section !== 'projects' && !this.allProjectsLoaded) {
        setTimeout(function () {
          comp.loadData('projects-full');
        }, 3000);
      }
      if (this.section !== 'journal') {
        setTimeout(function () {
          comp.loadData('journals');
        }, 5000);
      }
      setTimeout(function () {
        var otherNodes = _.filter(comp.nodes, function (n) {
          return n.alias !== '/' + comp.alias && n.alias.split('/').length < 3;
        });
        if (otherNodes.length > 0) {
          for (var i = 0; i < otherNodes.length; i++) {
            comp.getNode(otherNodes[i].nid, null, true);
          }
        }
      }, 4000);
    },
    preloadImg: function (imgSizes, addPreview) {
      var keys = Object.keys(imgSizes),
          i = 0,
          j = 0,
          len = keys.length,
          include = false,
          imgs = [],
          k,
          p,
          m,
          w;
      for (; i < len; i++) {
        k = keys[i];
        m = k.match(/_(\d+)[_x](\d+)/);
        if (m) {
          w = parseInt(m[1]);
          include = w > this.winWidth && w < this.maxWidth * 1.667;
          if (!include && addPreview === true) {
            include = w == this.previewWidth;
          }
          if (include && /^(scale_?crop|max_720)/.test(k)) {
            p = imgSizes[k];
            if (this.preloadedImgs.indexOf(p) < 0) {
              imgs[j] = new Image();
              imgs[j].src = p;
              this.preloadedImgs.push(p);
              j++;
            }
          }
        }
      }
    },
    checkEdited: function (init) {
      var comp = this;
      this.$http.get(this.backend + 'jsonstyles/edited').then(function (response) {
        if (response.data) {
          var data = response.data;
          if (typeof data === 'object') {
            if (data.nodes) {
              if (data.nodes instanceof Array) {
                this.$ls.set('editednodes', data);
                if (init === true) {
                  var d = comp.$ls.get('sitedata', {});
                  var updateProjects = false;
                  var updateHome = false;
                  var updateJournal = false;
                  var updateNode;
                  if (d.nodes) {
                    for (var i = 0; i < data.nodes.length; i++) {
                      var it = data.nodes[i];
                      var pi = _.findIndex(d.nodes, function (n) {
                        return n.nid == it.nid;
                      });
                      var sect = it.alias.replace(/^\//, '').split('/').shift();
                      updateNode = false;
                      if (pi > -1) {
                        if (it.changed > d.nodes[pi].changed) {
                          updateNode = true;
                        }
                      } else {
                        updateNode = true;
                      }
                      if (updateNode) {
                        switch (sect) {
                          case 'projects':
                            updateProjects = true;
                            break;
                          case 'home':
                            updateHome = true;
                            break;
                          case 'journal':
                            updateJournal = true;
                            break;
                        }
                      }
                    }
                    if (updateProjects) {
                      comp.$ls.remove('projects-full');
                      comp.$ls.remove('projects-full-more');
                      comp.loadData('projects-full');
                      comp.loadData('projects-full-more');
                    }
                    if (updateHome) {
                      comp.$ls.remove('home');
                      comp.loadData('home');
                    }
                    if (updateJournal) {
                      comp.$ls.remove('journals');
                      comp.loadData('journals');
                    }
                  }
                }
              }
            }
          }
        }
      }, function (response) {});
    },
    calcPageHeight: function () {
      var B = document.body;
      var H = document.documentElement;
      return Math.max(B.scrollHeight, B.offsetHeight, H.clientHeight, H.scrollHeight, H.offsetHeight);
    },
    handleScroll: function () {
      this.scrollY = scrollY();
      if (this.stopY > 0) {
        if (this.scrollY > this.prevY + this.stopY || this.scrollY < this.prevY - this.stopY) {
          this.prevStopY = this.prevY;
          this.prevY = this.scrollY;
          var sdClassIndex = this.containerClasses.indexOf('scrolled-down');
          if (this.scrollY > this.winHeight / 16) {
            if (sdClassIndex < 0) {
              this.addContainerClass('scrolled-down');
              this.$emit('scrolled-down', true);
            }
          } else {
            if (sdClassIndex >= 0) {
              this.removeContainerClass('scrolled-down');
            }
          }
        }
      }
    },
    handleResize: function (init) {
      var max = 1600;
      this.pageHeight = this.calcPageHeight();
      this.winHeight = window.innerHeight;
      this.winWidth = winWidth();
      this.maxWidth = this.winWidth > max ? max : this.winWidth;
      this.touchActive = this.winWidth < 1080 && this.touchEnabled;
      if (init === true) {
        this.stopY = this.winHeight / 64;
        this.halfWY = this.winHeight / 2;
      }
    },
    handleKeys: function (e) {
      switch (e.keyCode) {
        case 27:
        case 37:
        case 39:
          var path = this.$route.path;
          var isProject = /\/projects\/\w+/.test(path);
          break;
      }
      switch (e.keyCode) {
        case 27:
          if (isProject) {
            this.$router.push('/projects');
          }
          if (this.showAdmin) {
            this.showAdmin = false;
          }
          break;
        case 37:
          if (path === '/home') {
            this.$emit('nav-screen', 'prev');
          } else {
            window.history.back();
          }
          break;
        case 39:
          if (path === '/home') {
            this.$emit('nav-screen', 'next');
          } else if (isProject) {
            this.$emit('show-next-project', true);
          } else {
            window.history.forward();
          }
          break;
      }
    },
    menuToggle: function () {
      var index = this.containerClasses.indexOf('show-menu');
      if (index < 0) {
        this.containerClasses.push('show-menu');
      } else {
        this.containerClasses.splice(index, 1);
      }
    },
    clearLocalStorage: function () {
      var ts = Math.floor(new Date().getTime() / 1000);
      if (ts - 60 > this.clearTs) {
        this.$ls.clear();
        this.clearTs = ts;
        this.allProjectsLoaded = false;
        this.checkSiteInfo();
      }
    },
    addContainerClass: function (clsName) {
      this.toggleContainerClass(clsName, 'add');
    },
    removeContainerClass: function (clsName) {
      this.toggleContainerClass(clsName, 'rem');
    },
    toggleContainerClass: function (clsName, mode) {
      var index = this.containerClasses.indexOf(clsName);
      if (mode === 'add' && index < 0) {
        this.containerClasses.push(clsName);
      } else if (index >= 0) {
        switch (mode) {
          case 'rem':
          case 'remove':
            this.containerClasses.splice(index, 1);
            break;
        }
      }
    },
    closeAdmin: function () {
      this.adminUrl = '';
      this.checkEdited();
    },
    scrollTo: function (offsetY, reset) {
      if (this.scrolling === false) {
        this.scrolling = true;
        var comp = this;
        this.$scrollTo('body', 250, {
          offset: offsetY,
          easing: 'ease-in',
          cancelable: false,
          onDone: function () {
            comp.scrolling = false;
          },
          onCancel: false
        });
        if (!reset) {
          reset = 1000;
        }
        setTimeout(function () {
          comp.scrolling = false;
        }, reset);
      }
    },
    showNext: function () {
      this.$emit('show-next-project', true);
    },
    clearCaches: function () {
      this.$ls.clear();
      this.checkSiteInfo();
      this.showStatus("All local caches cleared");
    },
    showStatus: function (msg) {
      this.statusMsg = msg;
      this.showStatusMsg = true;
      var comp = this;
      setTimeout(function () {
        comp.showStatusMsg = false;
      }, 5000);
      setTimeout(function () {
        comp.statusMsg = '';
      }, 7000);
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VuePicture_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImageManager_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImageManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ImageManager_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__ImageManager_vue___default.a],
  data: function () {
    return {
      title: 'Welcome',
      content: {},
      slides: [],
      numSlides: 0,
      fullSizes: {},
      fixedSizes: {},
      notLoaded: true,
      timer: null,
      speed: 6000
    };
  },
  beforeRouteEnter: function (to, from, next) {
    next(function (vm) {
      vm.initPage();
    });
  },
  created: function () {
    var comp = this;
    this.timer = setInterval(function () {
      comp.nextSlide(true);
    }, this.speed);
    this.$parent.$on('nav-screen', function (val) {
      if (val == 'prev') {
        comp.nextSlide();
      } else {
        comp.nextSlide();
      }
    });
  },
  methods: {
    initPage: function () {
      var comp = this;
      this.$parent.scrollTo(0, 500);
      if (this.$parent.infoLoaded) {
        this.fullSizes = this.$parent.fullSizes;
        this.fixedSizes = this.$parent.fixedSizes;
        if (this.slides.length < 1) {
          this.loadHome();
        }
      } else {
        setInterval(function () {
          if (comp.$parent.infoLoaded && comp.notLoaded) {
            comp.fullSizes = comp.$parent.fullSizes;
            comp.loadHome();
          }
        }, 200);
      }
      setTimeout(function () {
        comp.$parent.scrollTo(0, 250);
      }, 500);
    },
    loadHome: function () {
      var comp = this;
      this.notLoaded = false;

      this.slides = [];
      this.$parent.loadData('home', function (data) {
        comp.$parent.currId = data.nid;
        comp.title = data.title;
        comp.content.body = data.body;
        if (data.sections) {
          var numSlides = data.sections.length;
          var index = 0;
          for (var i = 0; i < numSlides; i++) {
            var item = data.sections[i];
            var slide = {};
            if (item.image) {
              slide.image = item.image;
              if (item.link) {
                slide.link = item.link;
              }
              slide.index = index;
              slide.active = index === 0;
              comp.filterImgSizes(slide.image.sizes);
              comp.slides.push(slide);
              comp.$parent.preloadImg(slide.image.sizes);
              index++;
            }
          }
          comp.numSlides = comp.slides.length;
          comp.$parent.removeContainerClass('loading');
        }
      });
    },
    prevSlide: function () {
      this.setActive('prev');
    },
    nextSlide: function (auto) {
      this.setActive('next', auto);
    },
    setActive: function (index, auto) {
      var currIndex = _.findIndex(this.slides, function (slide) {
        return slide.active;
      });
      switch (index) {
        case 'next':
          if (currIndex < this.numSlides - 1) {
            index = currIndex + 1;
          } else {
            index = 0;
          }
          break;
        case 'prev':
          if (currIndex > 0) {
            index = currIndex - 1;
          } else {
            index = this.numSlides - 1;
          }
          break;
      }
      if (currIndex !== index && this.numSlides > index) {
        this.slides[index].active = true;
        if (currIndex >= 0 && currIndex < this.numSlides) {
          this.slides[currIndex].active = false;
        }
      }
      if (auto !== true) {
        if (this.timer) {
          clearInterval(this.timer);
        }
      }
    },
    loadLink: function (slide) {
      if (slide.link) {
        if (slide.link.url) {
          this.$router.push(slide.link.url);
        }
      }
    }
  },
  components: {
    VuePicture: __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue___default.a
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    filterImgSizes: function (sizes) {
      if (sizes instanceof Object && sizes !== null) {
        var keys = Object.keys(sizes),
            nk = keys.length,
            i = 0,
            k;
        for (; i < nk; i++) {
          k = keys[i];
          if (sizes[k].indexOf('/') === 0) {
            sizes[k] = this.$parent.mediabase + sizes[k].replace(/^\//, '');
          }
        }
      }
      return sizes;
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'journal',
  components: {},
  props: {},
  data: function () {
    return {
      title: 'Journal',
      loading: false,
      slides: [],
      numSlides: 0,
      scrolling: false,
      loadedMore: false,
      defaultSize: 'max_720x720',
      hasFullImage: false,
      mediaPlaying: '',
      imgsLoaded: false,
      fullCaption: '',
      fullSizes: {}
    };
  },
  beforeRouteEnter: function (to, from, next) {
    next(function (vm) {
      vm.initPage();
    });
  },
  created: function () {},
  watch: {},
  methods: {
    initPage: function () {
      this.fullSizes = this.$parent.fullSizes;
      if (this.loading !== true) {
        if (this.$parent.infoLoaded) {
          this.loadSlides(false);
          this.$parent.removeContainerClass('loading');
        } else {
          var comp = this;
          setInterval(function () {
            if (comp.$parent.infoLoaded && comp.numSlides < 1) {
              comp.loadSlides(false);
            }
          }, 200);
        }
      }
    },
    loadSlides: function (more) {
      var comp = this;
      var refName = 'journals';
      this.$parent.loadData('journals', function (data) {
        comp.addSlides(data);
        comp.$parent.removeContainerClass('loading');
      });
    },
    loadMoreSlides: function () {
      if (this.loadedMore === false) {
        this.loadSlides(true);
        this.loadedMore = true;
      }
    },
    addSlides: function (data, more) {
      this.numSlides = data.num_items;
      var slides = [];
      for (var i = 0; i < this.numSlides; i++) {
        if (typeof data.items[i] === 'object') {
          var it = data.items[i];
          if (i === 0) {
            this.$parent.currId = it.nid;
          }
          it.numImages = 0;
          it.hasSections = false;
          it.hasSingleImage = false;
          if (it.image) {
            it.hasSingleImage = it.image instanceof Object && it.image.sizes;
          }
          if (it.sections) {
            it.hasSections = it.sections.length > 0;
          }
          if (it.images instanceof Array || it.hasSingleImage) {
            this.processImages(it);
            if (it.hasSingleImage) {
              it.numImages = 1;
            }
          }
          slides.push(it);
        }
      }
      if (more) {
        this.slides = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.union(this.slides, slides);
      } else {
        this.slides = slides;
      }
      this.numSlides = this.slides.length;
      var comp = this;
      setTimeout(function () {
        comp.imgsLoaded = true;
        this.loading = false;
      }, 1000);
      setTimeout(this.layout, 1750);
      this.$parent.pageHeight = comp.$parent.calcPageHeight();
    },
    processImages: function (slide) {
      slide.hasImages = false;
      slide.images = [];
      if (slide.image) {
        if (slide.image.sizes) {
          slide.hasImages = true;
          slide.numImages = 1;
          slide.images = [slide.image];
        }
      }
      for (var j = 0; j < slide.numImages; j++) {
        var cln = 'index-0 active' + j;
        var attrs = slide.images[j].attributes;
        if (j === 0) {
          cln += ' active';
        }
        attrs.className = cln;
        if (slide.images[j].sizes) {
          var sizes = slide.images[j].sizes;
          if (typeof sizes === 'object') {
            slide.images[j] = {
              sizes: sizes,
              attributes: attrs,
              type: slide.images[j].type,
              picture: slide.images[j].picture
            };
          }
        }
      }
      slide.image = slide.images[0];
    },
    addImageClasses: function (slide) {
      slide.imageClasses = 'num-images-' + slide.numImages;
      if (slide.numImages > 1) {
        slide.imageClasses += ' has-many';
      }
      if (!slide.image_layout) {
        slide.image_layout = 'flex-row';
      }
      if (slide.numImages > 1 && slide.image_layout !== 'max-1') {
        slide.imageClasses += ' rows';
      }
      slide.imageClasses += ' ' + slide.image_layout;
    },
    updateCurrId: function (nid) {
      this.$parent.currId = nid;
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VuePicture_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VuePicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VuePicture_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ImageManager_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ImageManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ImageManager_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'node',
  directives: {
    scrollTo: __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__ImageManager_vue___default.a],
  data: function () {
    return {
      title: 'About',
      hasContent: false,
      content: {},
      fullSizes: {},
      updating: false,
      showTitle: true,
      loader: null
    };
  },
  beforeRouteEnter: function (to, from, next) {
    next(function (vm) {
      if (typeof vm.updateContent == 'function') {
        vm.updateContent(true);
      }
    });
  },
  created: function () {
    this.$parent.$on('node-update', this.updateContent);
  },
  methods: {
    updateContent: function (init) {
      if (!init) {
        init = false;
      }
      if (init !== true || this.$parent.infoLoaded) {
        this.updateNode();
      } else {
        var comp = this;
        this.loader = setInterval(function () {
          if (comp.$parent.infoLoaded) {
            comp.updateNode();
          }
        }, 200);
      }
    },
    updateNode: function () {

      if (!this.updating) {
        if (this.$parent.hasContent) {
          this.updating = true;
          this.title = this.$parent.title;
          this.hasContent = this.$parent.hasContent;
          this.content = this.$parent.content;
          this.fullSizes = this.$parent.fullSizes;
          if (this.loader) {
            clearInterval(this.loader);
          }
          this.showTitle = this.content.hasImage == false;
          var comp = this;
          if (this.content.hasImage) {
            this.filterImgSizes(this.content.image.sizes);
          }
          setTimeout(function () {
            comp.updating = false;
            comp.$parent.removeContainerClass('loading');
          }, 50);
        }
      }
    }
  },
  components: {
    VuePicture: __WEBPACK_IMPORTED_MODULE_2__VuePicture_vue___default.a
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueFlexpic_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueFlexpic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VueFlexpic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuePicture_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuePicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VuePicture_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueEmbedplayer_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueEmbedplayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VueEmbedplayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VueVideoplayer_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VueVideoplayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__VueVideoplayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VueAudioplayer_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VueAudioplayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__VueAudioplayer_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    section: {
      type: Object,
      default: function () {
        return {
          type: 'none',
          has_media: false,
          hasImages: false,
          images: [],
          title: '',
          text: '',
          media: {}
        };
      }
    },
    index: {
      type: Number,
      default: 0
    },
    sizes: {}
  },
  data: function () {
    return {
      mediaPlaying: '',
      classNames: []
    };
  },
  created: function () {
    this.mediaPlaying = this.$parent.mediaPlaying;
    this.classNames = ['section', 'section-' + this.index, this.section.type.toLowerCase().replace(/_/g, '-')];
  },
  components: {
    VuePicture: __WEBPACK_IMPORTED_MODULE_1__VuePicture_vue___default.a,
    VueFlexpic: __WEBPACK_IMPORTED_MODULE_0__VueFlexpic_vue___default.a,
    VueEmbedplayer: __WEBPACK_IMPORTED_MODULE_2__VueEmbedplayer_vue___default.a,
    VueVideoplayer: __WEBPACK_IMPORTED_MODULE_3__VueVideoplayer_vue___default.a,
    VueAudioplayer: __WEBPACK_IMPORTED_MODULE_4__VueAudioplayer_vue___default.a
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paragraph_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paragraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Paragraph_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    sections: {
      type: Array,
      default: function () {
        return [];
      }
    },
    sizes: {},
    nid: 0
  },
  data: function () {
    return {
      mediaPlaying: ''
    };
  },
  created: function () {
    this.mediaPlaying = this.$parent.mediaPlaying;
  },
  components: {
    Paragraph: __WEBPACK_IMPORTED_MODULE_0__Paragraph_vue___default.a
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_images_loaded__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_images_loaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_images_loaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueSlideshow_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueSlideshow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VueSlideshow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Paragraphs_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Paragraphs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Paragraphs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageManager_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ImageManager_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects',
  directives: {
    imagesLoaded: __WEBPACK_IMPORTED_MODULE_1_vue_images_loaded___default.a
  },
  components: {
    VueSlideshow: __WEBPACK_IMPORTED_MODULE_2__VueSlideshow_vue___default.a,
    Paragraphs: __WEBPACK_IMPORTED_MODULE_3__Paragraphs_vue___default.a
  },
  props: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_4__ImageManager_vue___default.a],
  data: function () {
    return {
      title: 'Projects',
      viewMode: 'show-listing',
      loading: false,
      slides: [],
      initSlideNum: 36,
      filter: 'all',
      filters: { all: 'Projects' },
      showFilters: false,
      numSlides: 0,
      prevStopY: 0,
      loadedMore: false,
      defaultSize: 'max_1300x1300',
      hasFullImage: false,
      mediaPlaying: '',
      fullNode: {
        nid: 0,
        title: '',
        body: '',
        images: [],
        sections: [],
        date: new Date().getFullYear().toString(),
        client_name: '',
        show_topimg: false
      },
      imgsLoaded: false,
      topCarousel: null,
      fullCaption: '',
      showFullCaption: false,
      fullSizes: {},
      fixedSizes: {},
      allSizes: {},
      fixedSize: 'scalecrop_640_464'
    };
  },
  beforeRouteEnter: function (to, from, next) {
    next(function (vm) {
      vm.loading = vm.slides.length > vm.initSlideNum;
      vm.initPage();
    });
  },
  created: function () {
    if (/^\/projects\/\w+/.test(this.$route.path)) {
      this.viewMode = 'show-detail';
    }
    this.showFilters = Object.keys(this.filters).length > 1;
    var comp = this;
    this.$parent.$on('scrolled-down', function (e) {
      if (!comp.loadedMore) {
        comp.loadMoreSlides();
      }
    });
    this.allSizes = {
      full: {},
      landscape: {},
      portrait: {}
    };
    this.$parent.$on('show-next-project', function (e) {
      comp.showNext();
    });
    this.$parent.$on('show-project', function (e) {
      comp.loadDetailNode(e.path);
    });
    window.addEventListener('hashchange', function (e) {
      comp.filterByHash();
    });
  },
  watch: {
    filters: function () {
      this.showFilters = Object.keys(this.filters).length > 1;
    },
    '$route.path': function () {
      this.updateView();
    }
  },
  methods: {
    initPage: function () {
      this.fullSizes = this.$parent.fullSizes;
      this.fixedSizes = this.$parent.fixedSizes;
      this.allSizes = {
        full: this.fullSizes,
        landscape: this.$parent.landscapeFixedSizes,
        portrait: this.$parent.portraitFixedSizes
      };
      if (/^projects\/\w+/.test(this.$parent.alias)) {
        this.viewMode = 'show-detail';
      }
      if (this.loading !== true) {
        if (this.$parent.infoLoaded) {
          var d = this.$ls.get('sitedata');
          if (d) {
            if (d.projects_init_load) {
              this.initSlideNum = parseInt(d.projects_init_load);
            }
          }
          this.loadSlides(false);
        } else {
          var comp = this;
          setInterval(function () {
            if (comp.$parent.infoLoaded == false && comp.numSlides < 1 && comp.loading == false) {
              comp.loadSlides(false);
            }
          }, 500);
        }
      }
    },
    updateView: function () {
      if (this.$parent.alias == 'projects') {
        this.hideFull();
      }
    },
    loadDetail: function () {
      var path = this.$route.path;
      if (path) {
        if (path.length > 2) {
          this.loading = true;
          if (path !== '/projects') {
            this.loadDetailNode(path);
          }
        }
      }
    },
    loadDetailNode: function (path) {
      var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.slides, function (slide) {
        return slide.path === path;
      });
      var comp = this;
      if (index >= 0) {
        this.showFullNode(this.slides[index], true);
        setTimeout(function () {
          comp.$parent.pageHeight = comp.$parent.calcPageHeight();
        }, 400);
      } else {
        var moreSlides = this.$ls.get('projects-full-more', null);
        if (moreSlides instanceof Array) {
          index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(moreSlides, function (slide) {
            return slide.path === path;
          });
          if (index >= 0) {
            comp.showFullNode(moreSlides[index], true);
          }
          this.loadSlides(true);
        }
      }
      setTimeout(function () {
        comp.loading = false;
      }, 200);
    },
    loadSlides: function (more) {
      var comp = this;
      var refName = 'projects-full';
      if (more) {
        refName += '-more';
      }
      var loading = this.loading;
      this.loading = true;
      this.$parent.loadData(refName, function (data) {
        comp.addSlides(data, more);
        var ms = comp.$parent.allProjectsLoaded ? loading ? 1500 : 10 : 3000;
        setTimeout(comp.loadMoreSlides, ms);
        comp.$parent.removeContainerClass('loading');
        comp.filterByHash();
      });
    },
    loadMoreSlides: function () {
      if (this.loadedMore === false) {
        this.loading = false;
        this.loadSlides(true);
        this.loadedMore = true;
      }
    },
    parseFilters: function (it) {
      if (it.hasOwnProperty('filter')) {
        if (this.filters.hasOwnProperty(it.filter) == false) {
          this.filters[it.filter] = it.category;
          this.showFilters = true;
        }
        it.classes = [it.filter, 'active'];
      }
    },
    filterSlides: function (filter) {
      if (!filter) {
        filter = 'all';
      }
      if (this.filter !== filter) {
        this.filter = filter;
        var i = 0,
            it;
        for (; i < this.slides.length; i++) {
          it = this.slides[i];
          if (this.filter === 'all' || this.filter === it.filter) {
            it.classes = [it.filter, 'active'];
          } else {
            it.classes = [it.filter, 'hidden'];
          }
        }
        if (this.filter !== 'all') {
          this.slides = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(this.slides, ['catweight', 'weight']);
        } else {
          this.slides = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(this.slides, ['weight']);
        }
      }
      window.location = '#' + filter;
    },
    filterByHash: function (init) {
      var sf = window.location.hash;
      var hasFilter = false;
      if (typeof sf == 'string') {
        sf = sf.replace(/^#+/g, '');
        hasFilter = sf.length > 2;
      } else if (init !== true) {
        sf = 'all';
        hasFilter = true;
      }
      if (hasFilter) {
        this.filterSlides(sf);
      }
    },
    addSlides: function (data, more) {
      var slides = [];
      for (var i = 0; i < data.items.length; i++) {
        if (typeof data.items[i] === 'object') {
          var it = data.items[i];
          it.numImages = 0;
          if (it.images instanceof Array) {
            this.processImages(it);
          }
          this.parseFilters(it);
          slides.push(it);
        }
      }

      if (more && this.slides.length > 0) {
        for (i = 0; i < slides.length; i++) {
          this.slides.push(slides[i]);
        }
        this.$parent.allProjectsLoaded = true;
      } else {
        this.slides = slides;
      }
      this.numSlides = this.slides.length;
      var comp = this;
      setTimeout(function () {
        comp.imgsLoaded = true;
        comp.loadDetail();
        this.loading = false;
      }, 375);
      this.$parent.pageHeight = comp.$parent.calcPageHeight();
    },
    processImages: function (slide) {
      slide.numImages = slide.images.length;
      slide.hasImages = slide.numImages > 0;
      for (var j = 0; j < slide.numImages; j++) {
        var cln = 'index-' + j;
        var attrs = slide.images[j].attributes;
        if (j === 0) {
          cln += ' active';
        }
        attrs.className = cln;
        if (slide.images[j].sizes) {
          var sizes = slide.images[j].sizes;
          if (typeof sizes === 'object') {
            this.filterImgSizes(sizes);
            this.$parent.preloadImg(sizes, j === 0);
            slide.images[j] = {
              sizes: sizes,
              attributes: attrs,
              type: slide.images[j].type,
              picture: slide.images[j].picture,
              active: j === 0,
              className: j === 0 ? 'active' : ''
            };
          }
        }
      }
    },
    fetchEdited: function (slide, index) {
      var comp = this;
      this.$http.get(this.$parent.backend + 'jsonstyles/node-full/' + slide.nid).then(function (response) {
        if (response.data instanceof Object) {
          comp.fullNode = response.data;
          var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(comp.slides, function (n) {
            return n.nid === comp.fullNode.nid;
          });
          if (index >= 0) {
            comp.slides[index] = response.data;
          }
          comp.updateFullNode();
        }
      }, function (response) {});
    },
    updateFullNode: function () {
      var cs = this.fullNode;
      cs.numImages = 0;
      cs.hasImages = false;
      if (!cs.show_topimg) {
        cs.show_topimg = false;
      }
      var comp = this;
      setTimeout(function () {
        comp.viewMode = 'show-detail';
      }, 250);
      if (cs.images) {
        if (cs.images instanceof Array) {
          cs.numImages = cs.images.length;
          cs.hasImages = cs.numImages > 0;
          this.addImageClasses(cs);
          for (var i = 0; i < cs.images.length; i++) {
            if (cs.images[i].sizes) {
              this.filterImgSizes(cs.images[i].sizes);
            }
          }
        }
      }
      if (cs.sections) {
        cs.numSections = 0;
        cs.hasSections = false;
        if (cs.sections instanceof Array) {
          cs.numSections = cs.sections.length;
          cs.hasSections = cs.numSections > 0;
          if (cs.hasSections) {
            for (var i = 0; i < cs.numSections; i++) {
              this.processImages(cs.sections[i]);
              this.addImageClasses(cs.sections[i]);
            }
          }
        }
      }
      if (!cs.client_name) {
        cs.client_name = '';
      }
    },
    addImageClasses: function (slide, extraClass) {
      slide.imageClasses = ['num-images-' + slide.numImages];
      if (slide.numImages > 1) {
        slide.imageClasses.push('has-many');
      }
      if (!slide.image_layout) {
        slide.image_layout = 'flex-row';
      }
      if (slide.numImages > 1 && slide.image_layout !== 'max-1') {
        slide.imageClasses.push('rows');
      }
      slide.imageClasses.push(slide.image_layout);
      if (slide.image_layout.indexOf('half-') == 0) {
        slide.imageClasses.push('half');
      } else if (slide.image_layout == 'half') {
        slide.imageClasses.push('half-natural');
      }
      if (extraClass) {
        slide.imageClasses.push(extraClass);
      }
      if (slide.numImages > 0) {
        var landscapeIndex = slide.image_layout === 'half-mixed' ? 0 : 1;
        for (var i = 0; i < slide.numImages; i++) {
          if (slide.numImages == 2) {
            switch (slide.image_layout) {
              case 'half-portrait':
                slide.images[i].aspect = 'portrait-fixed';
                break;
              case 'half-landscape':
                slide.images[i].aspect = 'landscape-fixed';
                break;
              case 'half-mixed':
              case 'half-mixed-2':
                switch (i) {
                  case landscapeIndex:
                    slide.images[i].aspect = 'landscape-fixed';
                    break;
                  default:
                    slide.images[i].aspect = 'portrait-fixed';
                    break;
                }
                break;
              default:
                slide.images[i].aspect = 'natural';
                break;
            }
          } else {
            slide.images[i].aspect = 'natural';
          }
        }
      }
    },
    removeTapClasses: function () {
      var i = 0,
          ti = -1,
          sl;
      for (; i < this.slides.length; i++) {
        sl = this.slides[i];
        if (sl.classes) {
          ti = sl.classes.indexOf('tapped');
          if (ti >= 0) {
            sl.classes.splice(ti, 1);
          }
        }
      }
    },
    showFullNode: function (slide, stopPop) {
      var skip = false;
      if (this.$parent.touchActive === true && stopPop !== true) {
        var ti = slide.classes.indexOf('tapped');
        this.removeTapClasses();
        if (ti < 0) {
          skip = true;
          slide.classes.push('tapped');
        }
      }
      if (!skip) {
        this.removeTapClasses();
        var index = this.$parent.matchEdited(slide);
        this.prevListY = this.$parent.scrollY;
        if (index < 0) {
          this.addImageClasses(slide, 'top-carousel');
          this.fullNode = slide;
          this.updateFullNode();
        } else {
          this.fetchEdited(slide, index);
        }
        this.$parent.currId = slide.nid;
        if (stopPop !== true) {
          this.$router.push(slide.path);
        }
        this.prevStopY = this.$parent.prevY;
        this.$parent.scrollTo(0, 500);
        if (!slide.classes) {
          slide.classes = [];
        }
        slide.classes.push('just-loaded');
        setTimeout(function () {
          var tempIndex = slide.classes.indexOf('just-loaded');
          if (tempIndex >= 0) {
            slide.classes.splice(tempIndex, 1);
          }
        }, 500);
      }
    },
    showNext: function (back) {
      var comp = this;
      var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.slides, function (n) {
        return n.nid === comp.fullNode.nid;
      });
      if (index >= 0 && this.loading == false) {
        var nextIndex = back === true ? index - 1 : index + 1;
        var numSlides = this.slides.length;
        if (nextIndex < 0) {
          nextIndex = numSlides - 1;
        } else if (nextIndex >= numSlides) {
          nextIndex = 0;
        }
        this.showFullNode(this.slides[nextIndex]);
      }
    },
    showPrev: function () {
      this.showNext(true);
    },
    hideFull: function (stopPop) {
      if (this.viewMode !== 'show-listing') {
        this.viewMode = 'show-listing';
        if (stopPop !== true) {
          var stateObj = { context: "parent" };
          history.pushState(stateObj, "Projects", "/projects");
        }
        var comp = this;
        this.loading = true;
        setTimeout(function () {
          if (comp.scrolling === false) {
            comp.scrolling = true;
            setTimeout(function () {
              comp.scrolling = false;
            }, 2000);
          }
          comp.loading = false;
        }, 100);
        setTimeout(function () {
          comp.$parent.pageHeight = comp.$parent.calcPageHeight();
          comp.$parent.scrollTo(comp.prevStopY, 333);
        }, 250);
      }
    },
    toggleCaption: function () {
      this.showFullCaption = !this.showFullCaption;
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function () {
    return {
      id: '',
      playing: false,
      tooltip: 'Play'
    };
  },
  props: {
    media: {},
    autoplay: false
  },
  created: function () {
    if (this.media.uris instanceof Array) {
      if (this.media.uris.length > 0) {
        this.id = this.media.uris[0].src;
      }
    }
  },
  methods: {
    play: function () {
      var audioEl = this.$el.querySelector('audio');
      if (audioEl) {
        if (audioEl.paused) {
          audioEl.play();
          this.tooltip = 'Pause';
        } else {
          audioEl.pause();
          this.tooltip = 'Play';
        }
      }
    },
    changeState: function () {
      var comp = this;
      setTimeout(function () {
        var audioEl = comp.$el.querySelector('audio');
        if (audioEl) {
          comp.tooltip = audioEl.paused ? 'Play' : 'Pause';
        }
      }, 50);
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function () {
    return {
      playing: false,
      playClass: 'preview'
    };
  },
  props: {
    media: {},
    current: ''
  },
  methods: {
    togglePlaymode: function () {
      this.playing = !this.playing;
      var comp = this;
      this.$on('media', function (uri) {
        if (uri !== this.media.uri) {
          comp.playing = false;
        }
      });
      if (this.playing) {
        if (this.media.uri) {
          this.$parent.mediaPlaying = this.media.uri;
        }
      }
    }
  },
  watch: {
    current: function () {
      if (this.current !== this.media.uri) {
        this.playing = false;
      }
    },
    playing: function () {
      this.playClass = this.playing ? 'playing' : 'preview';
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VuePicture_vue__);
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    imgset: {},
    sizes: {},
    aspect: {
      type: String,
      default: 'natural'
    },
    className: ''
  },
  data: function () {
    return {
      matchedSizes: {},
      defaultSize: 'max_720x720',
      classNames: []
    };
  },
  created: function () {
    this.classNames = [this.imgset.attributes.className, this.aspect];
    switch (this.aspect) {
      case 'portrait-fixed':
        this.matchedSizes = this.sizes.portrait;
        break;
      case 'landscape-fixed':
        this.matchedSizes = this.sizes.landscape;
        break;
      default:
        this.matchedSizes = this.sizes.full;
        break;
    }
  },
  components: {
    VuePicture: __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue___default.a
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    imgset: {},
    sizes: {},
    className: '',
    defaultSize: {
      type: String,
      default: 'max_720x720'
    }
  },
  data: function () {
    return {
      valid: false,
      defaultImage: ''
    };
  },
  created: function () {
    if (this.imgset.sizes instanceof Object && this.imgset.sizes !== null) {
      if (this.imgset.attributes instanceof Object) {
        if (this.imgset.attributes.width) {
          if (this.imgset.sizes) {
            this.valid = true;
          }
        }
      }
      if (this.valid) {
        if (this.imgset.sizes.hasOwnProperty(this.defaultSize)) {
          this.defaultImage = this.imgset.sizes[this.defaultSize];
        }
      }
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VuePicture_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    images: {
      type: Array,
      default: []
    },
    fullSizes: {},
    speed: {
      type: Number,
      default: 3000
    },
    showNav: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      currIndex: 0,
      timer: null
    };
  },
  created: function () {
    var comp = this;
    if (this.speed > 200 && comp.images.length > 1) {
      this.timer = setInterval(function () {
        if (comp.currIndex < comp.images.length - 1) {
          comp.currIndex++;
        } else {
          comp.currIndex = 0;
        }
      }, this.speed);
    }
  },
  methods: {
    setActive: function (index) {
      if (this.currIndex < this.images.length) {
        this.currIndex = index;
      } else {
        this.index = 0;
      }
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    next: function () {
      if (this.currIndex < this.images.length - 1) {
        this.setActive(this.currIndex + 1);
      } else {
        this.setActive(0);
      }
    },
    prev: function () {
      if (this.currIndex > 0) {
        this.setActive(this.currIndex - 1);
      } else {
        this.setActive(this.images.length - 1);
      }
    }
  },
  components: {
    VuePicture: __WEBPACK_IMPORTED_MODULE_0__VuePicture_vue___default.a
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function () {
    return {
      playing: false,
      playClass: 'preview',
      id: ''
    };
  },
  props: {
    media: {},
    current: ''
  },
  created: function () {
    if (this.media.uris instanceof Array) {
      if (this.media.uris.length > 0) {
        this.id = this.media.uris[0].src;
      }
    }
  },
  methods: {
    togglePlaymode: function () {
      this.playing = !this.playing;
      if (this.playing) {
        if (this.media.uris instanceof Array) {
          if (this.media.uris.length > 0) {
            this.$parent.mediaPlaying = this.id;
          }
        }
      }
    }
  },
  watch: {
    current: function () {
      if (this.current !== this.id) {
        this.playing = false;
      }
    },
    playing: function () {
      this.playClass = this.playing ? 'playing' : 'preview';
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ls__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






var options = {
  namespace: 'vuejs__'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_ls___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default.a, {
  preLoad: 1,
  error: '/static/images/loading-wheel.svg',
  loading: '/static/images/loading-wheel.svg',
  attempt: 1
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('toYear', function (value) {
  var m = value.match(/\b(\d\d\d\d)\b/);
  if (m) {
    return m[1];
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(50),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(45),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(40),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(42),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(52),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(46),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(47),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(48),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(41),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(49),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content-container node-page"
  }, [(_vm.hasContent) ? [_c('h2', {
    staticClass: "article-title",
    class: {
      'show-title': _vm.showTitle, 'hide-title': !_vm.showTitle
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.content.hasImage) ? [_c('figure', {
    staticClass: "main-image"
  }, [_c('vue-picture', {
    attrs: {
      "imgset": _vm.content.image,
      "sizes": _vm.fullSizes,
      "className": _vm.content.image.attributes.className
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.body)
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-picture', {
    attrs: {
      "imgset": _vm.imgset,
      "sizes": _vm.matchedSizes,
      "className": _vm.classNames
    }
  })
},staticRenderFns: []}

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classNames
  }, [(_vm.section.has_media) ? [_c('div', {
    staticClass: "media",
    class: _vm.section.media.type
  }, [(_vm.section.media.type == 'embed') ? [_c('vue-embedplayer', {
    attrs: {
      "media": _vm.section.media,
      "current": _vm.mediaPlaying
    }
  })] : _vm._e(), _vm._v(" "), (_vm.section.media.type == 'video') ? [_c('vue-videoplayer', {
    attrs: {
      "media": _vm.section.media,
      "current": _vm.mediaPlaying
    }
  })] : _vm._e(), _vm._v(" "), (_vm.section.media.type == 'audio') ? [_c('vue-audioplayer', {
    attrs: {
      "media": _vm.section.media,
      "current": _vm.mediaPlaying
    }
  })] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (_vm.section.hasImages) ? [_c('div', {
    staticClass: "pictures",
    class: _vm.section.imageClasses
  }, [_vm._l((_vm.section.images), function(img, imgIndex) {
    return [_c('figure', {
      key: imgIndex,
      class: 'fig-' + imgIndex
    }, [_c('vue-flexpic', {
      attrs: {
        "imgset": img,
        "sizes": _vm.sizes,
        "aspect": img.aspect,
        "className": img.attributes.className
      }
    }), _vm._v(" "), (img.attributes.title) ? _c('figcaption', [_vm._v(_vm._s(img.attributes.title))]) : _vm._e()], 1)]
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.section.type == 'quote') ? [(_vm.section.text) ? _c('blockquote', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.section.text)
    }
  }) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.section.title))])] : [(_vm.section.title) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.section.title))]) : _vm._e(), _vm._v(" "), (_vm.section.text) ? _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.section.text)
    }
  }) : _vm._e()]], 2)
},staticRenderFns: []}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.valid) ? _c('picture', {
    class: _vm.className
  }, [_vm._l((_vm.sizes), function(size, key) {
    return [(_vm.sizes[key]) ? _c('source', {
      attrs: {
        "srcset": _vm.imgset.sizes[key],
        "media": size
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.defaultImage,
      "width": _vm.imgset.attributes.width,
      "height": _vm.imgset.attributes.height,
      "alt": _vm.imgset.attributes.alt
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "top-header"
    }
  }, [_c('nav', {
    staticClass: "inner"
  }, [_c('h1', {
    attrs: {
      "id": "site-logo"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/home'
    }
  }, [_c('span', {
    staticClass: "alt-text"
  }, [_vm._v(_vm._s(_vm.siteName))])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "menu horizontal"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      class: 'item-' + index,
      on: {
        "click": function($event) {
          _vm.listen(item)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  })), _vm._v(" "), (_vm.isProjectPage) ? _c('div', {
    staticClass: "project-arrow icon-triangle-next",
    on: {
      "click": function($event) {
        _vm.showNext()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu-toggle icon-hamburger",
    on: {
      "click": function($event) {
        _vm.menuToggle()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.menu_toggle_label))])])]), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('ul', {
    staticClass: "bottom-list horizontal menu"
  }, [_c('li', {
    staticClass: "copyright",
    on: {
      "click": function($event) {
        _vm.clearCaches()
      }
    }
  }, [_vm._v(_vm._s(_vm.footer.copyright))]), _vm._v(" "), _vm._l((_vm.footer.menu), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), _vm._v(" "), (_vm.footer.email.length > 5) ? _c('li', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.footer.email
    }
  }, [_vm._v(_vm._s(_vm.footer.email))])]) : _vm._e()], 2), _vm._v(" "), (_vm.statusMsg.length > 1) ? _c('div', {
    staticClass: "status-msg",
    class: {
      'show': _vm.showStatusMsg
    }
  }, [_vm._v(_vm._s(_vm.statusMsg))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    attrs: {
      "id": "admin-bar"
    }
  }, [(_vm.currId > 0) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.showAdminOverlay()
      },
      "dblclick": function($event) {
        _vm.showAdminPage()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "overlay-container",
    class: {
      'show-admin': _vm.showAdmin
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAdmin),
      expression: "showAdmin"
    }],
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.hideAdminOverlay()
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": _vm.adminUrl,
      "id": "admin-frame",
      "name": "admin-frame"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container journal-container"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "journal-list listing",
    class: {
      'images-loaded': _vm.imgsLoaded
    }
  }, _vm._l((_vm.slides), function(slide, si) {
    return _c('article', {
      key: slide.nid,
      staticClass: "journal-entry",
      attrs: {
        "data-index": si,
        "data-path": slide.path
      },
      on: {
        "mouseover": function($event) {
          _vm.updateCurrId(slide.nid)
        }
      }
    }, [(slide.hasSingleImage) ? _c('figure', {
      staticClass: "half-width float-first"
    }, [_c('img', {
      attrs: {
        "src": slide.image.sizes[_vm.defaultSize],
        "width": slide.image.attributes.width,
        "height": slide.image.attributes.height
      }
    }), _vm._v(" "), (slide.image.attributes) ? _c('figcaption', [_c('div', {
      staticClass: "inner"
    }, [_vm._v("\n            " + _vm._s(slide.image.attributes.title) + "\n          ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "core-content half-width float-second"
    }, [_c('h4', {
      staticClass: "blog-title"
    }, [_vm._v(_vm._s(slide.title))]), _vm._v(" "), _c('time', {
      staticClass: "date",
      attrs: {
        "title": slide.date
      }
    }, [_vm._v(_vm._s(_vm._f("toYear")(slide.date)))]), _vm._v(" "), _c('div', {
      staticClass: "body",
      domProps: {
        "innerHTML": _vm._s(slide.body)
      }
    })])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container work-container",
    class: _vm.viewMode
  }, [_c('article', {
    staticClass: "work detail-content"
  }, [_c('div', {
    staticClass: "fixed-container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon-cancel",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.hideFull()
      }
    }
  })])]), _vm._v(" "), _c('v-touch', {
    staticClass: "swipe-back",
    attrs: {
      "tag": "div"
    },
    on: {
      "swipedown": _vm.hideFull
    }
  }), _vm._v(" "), (_vm.fullNode.show_topimg) ? _c('vue-slideshow', {
    attrs: {
      "images": _vm.fullNode.images,
      "fullSizes": _vm.fixedSizes,
      "defaultSize": "scale_crop_1024_461",
      "speed": 0
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "article-title"
  }, [_vm._v(_vm._s(_vm.fullNode.title))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('time', {
    staticClass: "date",
    attrs: {
      "title": _vm.fullNode.date
    }
  }, [_vm._v(_vm._s(_vm._f("toYear")(_vm.fullNode.date)))]), _vm._v(" "), (_vm.fullNode.client_name.length > 0) ? _c('h5', {
    staticClass: "client-name"
  }, [_vm._v(_vm._s(_vm.fullNode.client_name))]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.fullNode.category))])]), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.fullNode.body)
    }
  }), _vm._v(" "), (_vm.fullNode.hasSections) ? _c('paragraphs', {
    attrs: {
      "sections": _vm.fullNode.sections,
      "sizes": _vm.allSizes,
      "nid": _vm.fullNode.nid
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "projects main-content"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showFilters) ? _c('ul', {
    staticClass: "slide-filter horizontal"
  }, _vm._l((_vm.filters), function(name, key) {
    return _c('li', {
      class: {
        key: true, 'active': key === _vm.filter
      },
      on: {
        "click": function($event) {
          _vm.filterSlides(key)
        }
      }
    }, [_vm._v(_vm._s(name))])
  })) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "projects-list listing",
    class: {
      'images-loaded': _vm.imgsLoaded
    }
  }, _vm._l((_vm.slides), function(slide, si) {
    return _c('li', {
      key: slide.nid,
      class: slide.classes,
      attrs: {
        "data-index": si,
        "data-path": slide.path,
        "data-nid": slide.nid
      }
    }, [_c('figure', {
      staticClass: "preview",
      attrs: {
        "data-num": slide.images.length
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showFullNode(slide)
        }
      }
    }, [_vm._l((slide.images), function(img, index) {
      return [(index < 1) ? [_c('img', {
        attrs: {
          "src": img.sizes[_vm.fixedSize],
          "width": img.attributes.width,
          "height": img.attributes.height
        }
      })] : _vm._e()]
    }), _vm._v(" "), _c('figcaption', [_c('div', {
      staticClass: "inner"
    }, [_c('h4', {
      attrs: {
        "title": slide.category
      }
    }, [_vm._v(_vm._s(slide.title))])])])], 2)])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audio-player"
  }, [(_vm.media.has_preview) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.media.preview,
      "title": _vm.tooltip
    },
    on: {
      "click": function($event) {
        _vm.play()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('audio', {
    staticClass: "audio-control",
    attrs: {
      "controls": "",
      "autoplay": _vm.autoplay
    }
  }, _vm._l((_vm.media.uris), function(uri) {
    return _c('source', {
      attrs: {
        "src": uri.src,
        "type": uri.mimetype
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "player embed",
    class: _vm.playClass
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.togglePlaymode()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.media.preview
    }
  })]), _vm._v(" "), (_vm.playing) ? _c('iframe', {
    attrs: {
      "src": _vm.media.uri,
      "width": _vm.media.width,
      "height": _vm.media.height
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "player video",
    class: _vm.playClass
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.togglePlaymode()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.media.preview
    }
  })]), _vm._v(" "), (_vm.playing) ? _c('video', {
    attrs: {
      "controls": "",
      "autoplay": ""
    }
  }, _vm._l((_vm.media.uris), function(uri) {
    return _c('source', {
      attrs: {
        "src": uri.src,
        "type": uri.mimetype
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content-container home"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "slide-container"
  }, [_c('v-touch', {
    staticClass: "slides swipe",
    attrs: {
      "tag": "ul"
    },
    on: {
      "swipeleft": _vm.nextSlide,
      "swiperight": _vm.prevSlide
    }
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('li', {
      class: {
        active: slide.active
      },
      on: {
        "click": function($event) {
          _vm.loadLink(slide)
        }
      }
    }, [_c('vue-picture', {
      attrs: {
        "imgset": slide.image,
        "sizes": _vm.fixedSizes,
        "defaultSize": "scale_crop_1024_461"
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "arrow prev icon-triangle-prev",
    on: {
      "click": function($event) {
        _vm.prevSlide()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow next icon-triangle-next",
    on: {
      "click": function($event) {
        _vm.nextSlide()
      }
    }
  }), _vm._v(" "), _c('nav', [_c('ol', {
    staticClass: "horizontal circles plain"
  }, [_vm._l((_vm.slides), function(slide, index) {
    return [_c('li', {
      class: {
        active: slide.active
      },
      on: {
        "click": function($event) {
          _vm.setActive(index)
        }
      }
    }, [_vm._v(_vm._s(slide.index + 1))])]
  })], 2)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "carousel"
  }, [(_vm.images.length > 0) ? _c('div', {
    staticClass: "pictures top-carousel",
    class: 'num-images-' + _vm.images.length
  }, _vm._l((_vm.images), function(img, index) {
    return _c('figure', {
      class: {
        'active': _vm.currIndex === index
      },
      on: {
        "click": function($event) {
          _vm.next()
        }
      }
    }, [(img.picture) ? [_c('vue-picture', {
      attrs: {
        "imgset": img,
        "sizes": _vm.fullSizes,
        "className": img.attributes.className
      }
    })] : [_c('picture', {
      staticClass: "original",
      class: img.attributes.className
    }, [_c('img', {
      attrs: {
        "src": img.sizes.orig,
        "alt": img.attributes.alt,
        "width": img.attributes.width,
        "height": img.attributes.height
      }
    })])], _vm._v(" "), (img.attributes.title) ? _c('figcaption', [_vm._v(_vm._s(img.attributes.title))]) : _vm._e()], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('div', {
    staticClass: "arrow prev icon-triangle-prev click-overlay",
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('div', {
    staticClass: "arrow next icon-triangle-next click-overlay",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('v-touch', {
    staticClass: "arrow prev touch-overlay",
    attrs: {
      "tag": "div"
    },
    on: {
      "tap": function($event) {
        _vm.prev()
      },
      "swiperight": _vm.prev
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('v-touch', {
    staticClass: "arrow next touch-overlay",
    attrs: {
      "tag": "div"
    },
    on: {
      "tap": function($event) {
        _vm.next()
      },
      "swipeleft": _vm.next
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNav && _vm.images.length > 1) ? _c('nav', {
    staticClass: "horizontal circles plain "
  }, [(_vm.images.length > 0) ? _c('ol', _vm._l((_vm.images), function(img, index) {
    return _c('li', {
      class: {
        'active': _vm.currIndex === index
      },
      on: {
        "click": function($event) {
          _vm.setActive(index)
        }
      }
    }, [_vm._v(_vm._s((index + 1)))])
  })) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sections.length > 0) ? _c('section', {
    staticClass: "sections"
  }, [_vm._l((_vm.sections), function(section, index) {
    return [_c('paragraph', {
      key: _vm.nid + '_' + index,
      attrs: {
        "section": section,
        "index": index,
        "sizes": _vm.sizes
      }
    })]
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[25]);


// WEBPACK FOOTER //
// static/js/app.f7677958315849512c42.js